$('.type-detail .p-detail>.products-additional').slick({
  slidesToShow: 4,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: false,
 arrow: true,
 infinite: false,
 responsive: [
   {
     breakpoint: 1199,
     settings: {
       slidesToShow: 3,
       slidesToScroll: 1,
       arrow: true,
       dots: true,
     }
   },
   {
     breakpoint: 767,
     settings: {
      slidesToShow: 2,
      slidesToScroll: 1,

      arrow: true,
      dots: false,
    }
    
   }
   ,
   {
     breakpoint: 600,
     settings: {
      slidesToShow: 1,
      slidesToScroll: 1,

      arrow: true,
      dots: false,
    }
    
   }
 ]
});

$('.in-index .products').slick({
  slidesToShow: 5,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: false,
 arrows: true,
 infinite: true,
 responsive: [
   {
     breakpoint: 1300,
     settings: {
       slidesToShow: 4,
       slidesToScroll: 1,
     }
   },
   {
     breakpoint: 1050,
     settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    }
    
   },
   {
     breakpoint: 900,
     settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    }
  }
  ,
   {
     breakpoint: 768,
     settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
    }
  }
 ]
});

$('.usp').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  dots: false,
  arrows: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
});